<div class="container">
    <div class="card mt-3">
        <div class="dashboard-card-body card-body notification">
            <div class="table-responsive">
                <table class="table">
                    <tbody>
                        <tr *ngFor="let notification of notifications" [class.unread]="notification.status=='UNREAD'">
                          <td>
                            <div class="d-flex justify-content-between align-items-center">
                              <div class="d-flex align-items-center">
                                <div class="table-noti-icon">
                                  <i [class]="sharedService.getNotificationIcon(notification.type)"></i>
                                </div>
                                <div class="table-noti-message ml-3">
                                  <h6>
                                    <a href="javascript:void(0);">{{ notification.title }}</a>
                                  </h6>
                                  <p>{{ notification.body }}</p>
                                  <!-- Display calculated time -->
                                  <span class="message-time">{{ notification.timestamp.toDate() | date:'medium' }}</span>
                                </div>
                              </div>
                              <div class="position-relative">
                                <button class="btn btn-sm btn-light" 
                                        (click)="toggleDropdown(notification)">
                                  <i class="fas fa-ellipsis-v"></i>
                                </button>
                                <div *ngIf="notification.isOpen" class="dropdown-menu show">
                                  <button class="dropdown-item" (click)="markAsRead(notification)">Als gelesen markieren</button>
                                  <button class="dropdown-item text-danger" (click)="deleteNotification(notification)">Löschen</button>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <div class="alert alert-info" *ngIf="notifications.length == 0 && showSpinner == false">
                            <i class="fa-solid fa-circle-info me-2"></i>Keine Benachrichtigungen gefunden
                          </div>
                        </tr>
                        <tr *ngIf="showSpinner" style="text-align: center;">
                          <td colspan="7">
                            <div class="spinner-border text-primary" role="status">
                              <span class="visually-hidden">Lädt...</span>
                            </div>
                          </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>